module.exports = __webpack_public_path__ + "static/media/x-trail-side.ec83f411.jpg";